/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class MonthSelectorDirectiveController {
        public static $inject: string[] = [
            '$mobilityCompanyAuthentication', 
            '$window',
            '$dealerwareNotification',
            '$dealerwareInternationalizationData'
        ];

        public selectedMonth: number;
        public selectedYear: number;
        public localeLng: string;

        private locationCreatedYear: number;

        constructor(public $auth: any, public $window: any, public $dealerwareNotification, public $dealerwareInternationalizationData: any) {
            this.localeLng = $window.localStorage.getItem('language')

            this.getMomentLocale();

            var now = moment();

            this.locationCreatedYear = moment(this.$auth.location.created_at).year();

            if (!this.selectedMonth) { this.selectedMonth = now.month(); }
            if (!this.selectedYear)  { this.selectedYear = now.year(); }
        }

        public getMomentLocale() {

            const _self = this;
            this.$dealerwareInternationalizationData
                .getMomentDataFromLocale()
                .then( function(res) {
                    moment.locale(_self.localeLng, res.data[_self.localeLng]);
                },
                function(error: any) {
                    _self.$dealerwareNotification.apiError(error);
                }
            );
        }

        public get months() : string[] {
            return moment.months();
        }

        public get years() : number[] {
            var years: number[] = [];

            for (var i=this.locationCreatedYear; i <= moment().year(); i++) {
                years.push(i);
            }

            return years;
        }

        public monthLimit() : number {
            var now = moment();

            return this.selectedYear == now.year() ? now.month() : undefined;
        }
    }

    getDealerwareWebComponentsModule().controller('MonthSelectorDirectiveController', MonthSelectorDirectiveController);

    export class MonthSelectorDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'MonthSelectorDirectiveController';
        public controllerAs     : string    =   'monthSelectorController';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   {
            selectedMonth: '=',
            selectedYear: '='
        };
        public transclude       : boolean   =   false;
        public templateUrl      : string    =   '/components/reports/month_selector.html';
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {}
    }

    getDealerwareWebComponentsModule().directive("dealerwareMonthSelector",() => new MonthSelectorDirective());
 }
